import React, { useEffect, useState } from "react";
import { admin } from "../../lib/api";

export default function ReviewQueue() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);
  const load = async () => {
    setLoading(true);
    const res = await admin.queue();
    setRows(res.rows);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const release = async (id) => {
    setBusy(id);
    try {
      await admin.release(id);
      await load();
    } finally { setBusy(null); }
  };

  return (
    <div data-testid="review-queue-page">
      <div className="cw-eyebrow">Review Queue</div>
      <h1 className="cw-display-l" style={{ marginTop: 8 }}>Held reports.</h1>
      <p className="cw-body" style={{ marginTop: 8, color: "rgba(22,30,27,0.72)" }}>
        Reports for leads scoring at or above the review threshold sit here until released. TIER_1 never auto-releases.
      </p>
      {loading && <p style={{ marginTop: 24 }} data-testid="queue-loading">Loading…</p>}
      {!loading && (
        <div className="cw-card" style={{ marginTop: 24, padding: 0, overflowX: "auto" }}>
          <table className="cw-table" data-testid="queue-table">
            <thead>
              <tr>
                <th>Respondent</th>
                <th>Organisation</th>
                <th>Sector</th>
                <th>Country</th>
                <th>Tier</th>
                <th>Score</th>
                <th>Waiting (h)</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.report_id} data-testid={`queue-row-${r.report_id}`}>
                  <td>{r.full_name}</td>
                  <td>{r.organisation}</td>
                  <td>{r.sector}</td>
                  <td>{r.country}</td>
                  <td>{r.tier}</td>
                  <td>{r.lead_score}</td>
                  <td style={{ color: r.waiting_hours >= 3 ? "var(--cw-marigold)" : "inherit" }}>
                    {r.waiting_hours}
                  </td>
                  <td>
                    <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                      <a
                        className="cw-btn-text"
                        href={admin.pdfUrl(r.report_id)}
                        target="_blank" rel="noopener noreferrer"
                        data-testid={`preview-${r.report_id}`}
                      >Preview</a>
                      <button
                        className="cw-btn light-primary"
                        style={{ height: 40, padding: "0 20px" }}
                        onClick={() => release(r.report_id)}
                        disabled={busy === r.report_id}
                        data-testid={`release-${r.report_id}`}
                      >{busy === r.report_id ? "Releasing…" : "Release"}</button>
                    </div>
                  </td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={8} style={{ textAlign: "center", color: "rgba(22,30,27,0.72)" }}>Queue is empty.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
